'use strict';
// const _ = require('underscore'),
const colorParser = require('./color-parser'),
	isObjectObject = require('@mindmup/js-utils/src/is-object-object'),
	fontParser = require('./font-parser'),
	addPx = require('../util/px');
module.exports = function ThemeProcessor() {
	const self = this,
		cssProp = {
			cornerRadius: 'border-radius',
			'text.color': 'color',
			background: 'background-color',
			backgroundColor: 'background-color',
			border: 'border',
			shadow: 'box-shadow',
			'text.font': 'font',
			'text.alignment': 'text-align'
		},
		parsers = {
			cornerRadius: addPx,
			background: colorParser,
			border: function (borderOb) {
				if (!borderOb.line || borderOb.type === 'underline' || borderOb.type === 'overline') {
					return '0';
				}
				const margin = Number.isFinite(borderOb.line.margin) ? borderOb.line.margin : -1 * borderOb.line.width,
					marginSubStyle = margin ? ';margin:' + addPx(margin) : '';
				return borderOb.line.width + 'px ' + (borderOb.line.style || 'solid') + ' '  + borderOb.line.color + marginSubStyle;
			},
			shadow: function (shadowArray) {
				const boxshadows = [];
				if (shadowArray.length === 1 && shadowArray[0].color === 'transparent') {
					return 'none';
				}
				shadowArray.forEach((shadow) => {
					boxshadows.push(shadow.offset.width + 'px ' + shadow.offset.height + 'px ' + shadow.radius + 'px ' + colorParser(shadow));
				});
				return boxshadows.join(',');
			},
			'text.font': fontParser
		},
		processNodeStyles = function (themeDictionary) {
			let parser, cssVal;
			const result = [],
				identity = (v) => v,
				nodeStyleArray = Array.isArray(themeDictionary.node) ? themeDictionary.node : themeDictionary.nodeOrder.map(name => Object.assign({name}, themeDictionary.node[name])),
				pushProperties = (styleObject, keyPrefix) => {
					Object.keys(styleObject).forEach(propKey => {
						const val = styleObject[propKey],
							key = (keyPrefix || '') + propKey;
						if (cssProp[key]) {
							parser = parsers[key] || identity;
							cssVal = parser(val);
							if (cssVal) {
								result.push(cssProp[key]);
								result.push(':');
								result.push(cssVal);
								result.push(';');
							}
						} else if (isObjectObject(val)) {
							pushProperties(val, key + '.');
						}
					});
				},
				appendDecorationStyles = function (styleSelector, nodeStyle) {
					if (!nodeStyle || !nodeStyle.decorations) {
						return;
					}
					const fontSize = nodeStyle.decorations.height - 2 * nodeStyle.decorations.margin,
						stickersStyle = nodeStyle.decorations.stickers || nodeStyleArray[0].decorations.stickers;
					result.push(styleSelector);
					result.push(' .mapjs-decorations{position:absolute;');
					result.push(`font-size:${fontSize}px;line-height:1;`);
					result.push(`color:${nodeStyle.decorations.color};`);
					result.push(`background-color:${nodeStyle.decorations.backgroundColor};`);
					result.push(`border-radius:${addPx(nodeStyle.decorations.cornerRadius)};`);
					result.push(`opacity:${nodeStyle.decorations.opacity};`);
					result.push(`padding:${nodeStyle.decorations.margin}px;`);
					result.push('}');

					result.push(styleSelector);
					result.push(' .mapjs-decorations a {');
					result.push(`padding:${nodeStyle.decorations.margin}px;`);
					result.push(`color:${nodeStyle.decorations.color};`);
					result.push(`background-color:${nodeStyle.decorations.backgroundColor};`);
					result.push(`border-radius:${addPx(nodeStyle.decorations.cornerRadius)};`);
					result.push('}');


					if (nodeStyle.decorations.label) {
						result.push(styleSelector);
						result.push(' .mapjs-decorations .mapjs-label{');
						result.push('min-width:1em;');
						result.push(`font:${fontParser(nodeStyle.decorations.label.font)};`);
						result.push(`border:${addPx(nodeStyle.decorations.label.border)} solid ${nodeStyle.decorations.color};`);
						result.push(`border-radius:${addPx(nodeStyle.decorations.label.cornerRadius)};`);
						result.push(`padding:${addPx(nodeStyle.decorations.label.margin)};`);
						result.push('}');
					}

					if (stickersStyle) {
						result.push(styleSelector);
						result.push(' .mapjs-decorations .mapjs-stickers {');
						result.push(`font-family:${fontParser(stickersStyle.font, {familyOnly: true})};`);
						result.push('font-weight: normal;');
						result.push('}');
					}
				};
			nodeStyleArray.forEach((nodeStyle) => {
				let styleSelector = '.mapjs-node';
				if (nodeStyle.name !== 'default') {
					styleSelector = styleSelector + '.' + nodeStyle.name.replace(/\s/g, '_');
				}
				result.push(styleSelector);
				result.push('{');
				pushProperties(nodeStyle);
				result.push('}');
				appendDecorationStyles(styleSelector, nodeStyle);
			});
			return result;
		},
		processThemeStyles = (theme) => {
			if (theme.noAnimations) {
				return [];
			}
			return ['body:not(.noTransition) .mapjs-node:not(.noTransition):not(.dragging), body:not(.noTransition) [data-mapjs-role="svg-container"] :not(.noTransition), body:not(.noTransition) [data-mapjs-role="svg-container"] :not(.noTransition) :not(.noTransition) { transition-property: transform, left, d, top, opacity; transition-duration: 400ms;}'];
		};
	self.process = function (theme) {
		let nodeStyles = '';
		if (theme.node) {
			nodeStyles = processThemeStyles(theme).concat(processNodeStyles(theme)).join('');
		}
		return {
			css: nodeStyles
		};
	};
	self.cssFont = parsers['text.font'];
};
